import React from 'react';
import PropTypes from 'prop-types';
import { useIntl } from 'react-intl';
import {
	AlertIcon,
	Dialogue,
	FlexContainer,
	Success,
} from '@silverrailtech/srtlibrary';
import messages from '../../messagesOuigoRefunds';

const VoucherSubmissionResultDialogue = ({
	messages: backendMessages,
	onClose,
	result,
}) => {
	const { formatMessage } = useIntl();

	if (result === null) {
		return null;
	}

	const isSuccess = result === 'success';
	const responseMessage = backendMessages.join(' ');

	return (
		<Dialogue
			onClose={onClose}
			open
			primaryAction={
				!isSuccess
					? {
							label: formatMessage(messages.lblClose),
							onClick: onClose,
						}
					: undefined
			}
			title={
				<FlexContainer align="center" as="span" direction="row" gap="8px">
					{isSuccess ? (
						<Success height={16} width={16} />
					) : (
						<AlertIcon height={16} width={16} />
					)}
					{responseMessage}
				</FlexContainer>
			}
		/>
	);
};

VoucherSubmissionResultDialogue.propTypes = {
	messages: PropTypes.arrayOf(PropTypes.string).isRequired,
	onClose: PropTypes.func.isRequired,
	result: PropTypes.oneOf(['error', 'partial', 'success']),
};

export default VoucherSubmissionResultDialogue;
